import { Event } from "./Event";

export class EventDelete extends Event {
}